import { render, staticRenderFns } from "./RatePlanModal.vue?vue&type=template&id=58235054&scoped=true&"
import script from "./RatePlanModal.vue?vue&type=script&lang=js&"
export * from "./RatePlanModal.vue?vue&type=script&lang=js&"
import style0 from "./RatePlanModal.vue?vue&type=style&index=0&id=58235054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58235054",
  null
  
)

export default component.exports